import gql from 'graphql-tag';

export default gql`
  mutation updateAgentsMutation($input: UpdateAgentsInput) {
    agentsUpdate(input: $input)
  }
`;
